import { ByProject, CostCenterData, IssuerData } from "~/application/types/entities/CustomerBI.type";
import { Box } from "~/components/Box";
import { Card } from "~/components/Card";
import { Flex } from "~/components/Flex";
import { Text } from "~/components/Text";
import { H4 } from "~/components/Typography";
import { asCurrency } from "~/utils/mask.utils";

type IssuerResumeProps = {
  projects?: ByProject[];
  onSelectMultiValues: IssuerResumeSelectHandler;
  selectedMultiValues: IssuerResumeSelectedValues;
};

type IssuerResumeSelectHandler = ({ value, field }: { value: string; field: "projects" }) => void;

type IssuerResumeSelectedValues = {
  projects: string[];
};

export function ByProjectList({
  projects,
  onSelectMultiValues,
  selectedMultiValues,
}: IssuerResumeProps) {
  return (
    <>
      <Card css={{ height: "600px" }}>
        <Flex css={{ p: "$5" }}>
          <H4>Valor Por Projeto</H4>
        </Flex>
        <Box css={{ overflow: "auto" }}>
          {projects?.map((project) => (
            <>
              <Flex
                justify="between"
                key={`isser-resume-${project.uuid}`}
                onClick={() => onSelectMultiValues({ value: project.uuid, field: "projects" })}
                css={{
                  p: "$4",
                  borderRadius: "$2",
                  backgroundColor: selectedMultiValues.projects?.includes(project.uuid)
                    ? "$primary-light"
                    : "transparent",
                  alignItems: "center",
                  borderBottom: "1px solid $neutrals-lightest",
                  cursor: "pointer",
                  "&:hover": {
                    backgroundColor: "$neutrals-lightest",
                  },
                }}
              >
                <Flex align="center" gap="4">
                  <Flex gap="1" direction="column" justify="center">
                    <Text fw="600">{project.name}</Text>
                    <Text css={{ fontSize: "$sm", color: "$neutrals-darkest" }}>
                      Último pedido: {project.lastOrderDate}
                    </Text>
                  </Flex>
                </Flex>
                <Text fw="700" css={{ color: "$success-base" }}>
                  {asCurrency(project.value)}
                </Text>
              </Flex>
            </>
          ))}
        </Box>
      </Card>
    </>
  );
}
